
import Checklist from 'vux/src/components/checklist/index.vue'
import Confirm from 'vux/src/components/confirm/index.vue'
import Group from 'vux/src/components/group/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import XButton from 'vux/src/components/x-button/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'


export default {
name: "filing",
components: {Group, XInput, XButton, Confirm, Checklist},
directives: {TransferDom},
data() {
return {
devtypeshow: false,
smsDisabled: false,
buttonText: '发送验证码',
fastprojectshow: false,
code: '',
imgcode:'',
imgCodeInput: '',
imgCodeError: '',
data: {
customer: '',
devtype: '',
agent: '',
company: '北京中广上洋科技股份有限公司',
},
devtypeOther: '',
name: '',
mobile: '',
quoteLine: [],
checklist001: [],
isLogin: false,
isDisabled: false
}
},
methods: {
clear() {
this.data = {
customer: '',
devtype: '',
agent: '',
company: '北京中广上洋科技股份有限公司',
}
if (!this.isLogin) {
this.name = ''
this.mobile = ''
}
this.checklist001 = []
},
goToList() {
if (this.isLogin) {
this.$router.push({name: 'filinglist'})
} else {
this.$vux.alert.show({
title: "",
content: "暂无订单信息"
});
}
},
sendCode() {

if (!this.imgCodeInput) {
this.imgCodeError = '请输入图形验证码'
return
}

const obj = {
nationcode: '86',
mobile: this.mobile,
openid : localStorage.getItem('openid'),
passwd: this.imgCodeInput
}
if (this.mobile) {
this.$http.post('/api/v1/accounts/sms', obj)
.then((response) => {
if (response.data.result !== 0) {
this.imgCodeError = response.data.errmsg || '验证码发送失败'
} else {
this.imgCodeError = ''
localStorage.setItem('countDown', 60)
this.timeKeeping()
}
})
.catch((error) => {
if (error.response && error.response.data) {
this.imgCodeError = error.response.data.errmsg || '图形验证码错误'
} else {
this.imgCodeError = '发送失败，请重试'
}
})
}
},
timeKeeping() {
this.smsDisabled = true
const interval = setInterval(() => {

let countDown = parseInt(localStorage.getItem('countDown'))

this.buttonText = countDown + '秒'

if (countDown === 0) {
clearInterval(interval)
localStorage.removeItem('countDown')
this.buttonText = '重新发送'
this.smsDisabled = false
} else {
countDown--
localStorage.setItem('countDown', countDown)
}
}, 1000)
},
getImgCode() {
this.$http.get('/api/v1/photos/get_imgcode').then((response) => {
this.imgcode = response.data
}).catch(() => {
this.imgCodeError = '获取图形验证码失败'
})
},
refreshImgCode() {
this.imgCodeInput = ''
this.imgCodeError = ''
this.getImgCode()
},
onConfirm() {
const info = {
code: this.code,
mobile: this.mobile
}
this.$http.put('/api/v1/accounts/checksms', info).then(() => {
this.$http.post('/api/v1/srvp_projects/report', {
info: this.data,
name: this.name,
mobile: this.mobile,
openid: localStorage.getItem('openid'),
unionid: localStorage.getItem('unionid'),
nickname: localStorage.getItem('nickname'),
imgurl: localStorage.getItem('imgurl'),
otp:'official'
}).then(response => {
alert('提交成功');
this.isDisabled = false
this.clear()
this.$router.push({name: 'filinglist'})
}).catch(error => {
this.isDisabled = false
this.$vux.alert.show({
title: '',
content: JSON.parse(error.response.data.error_message).zh_string,
})
})
})
},
choseDevtype() {
this.devtypeshow = true;
},
sureDevtype() {
this.data.devtype = this.checklist001.join(',')
},
check() {
this.isDisabled = true
if (this.data.customer !== '' && this.data.devtype !== '' && this.data.agent !== '' && this.mobile && this.name) {
if (this.isLogin) {
var obj = {
headers: {
token: localStorage.getItem('token'),
opid: localStorage.getItem('userid')
}
}
this.$http.post('/api/v1/srvp_projects/admin_report', {
role: 'INDV',
info: this.data,
}, obj).then(() => {
this.isDisabled = false
alert('提交成功');
this.$router.push({name: 'filinglist'})
}).catch(error => {
this.isDisabled = false
this.$vux.alert.show({
title: '',
content: JSON.parse(error.response.data.error_message).zh_string,
})
})
} else {
this.fastprojectshow = true
this.refreshImgCode() 
}
} else {
alert('请补充信息');
this.isDisabled = false
}
}
},
computed: {
fls: function () {
return this.data.devtype === '其他'
}
},
mounted() {
this.$nextTick(() => {
this.$refs.devtype.$el.getElementsByClassName('weui-dialog')[0].setAttribute('id', 'auto');
})
},
created() {
var unionid = localStorage.getItem('unionid')
this.$http.get('api/v1/srvp_products/user_list_cats?company=北京中广上洋科技股份有限公司&hint=').then((response) => {
this.quoteLine = response.data
})
this.$http.get('api/v1/wechat/' + unionid).then((res) => {
let len = res.data.length
if (len) {
let account = res.data[0].account
localStorage.setItem('account', account)
this.$http.post('api/v1/wechat/' + unionid + '/token', {'account': account})
.then((res) => {
localStorage.setItem('token', res.data.token)
localStorage.setItem('userid', res.data.userid)
var opid = res.data.userid
var obj = {
headers: {
token: res.data.token,
opid: res.data.userid
}
}

this.$http.get('api/v1/accounts/' + opid, obj).then((response) => {
for (let i = 0; i < response.data.length; i++) {
if (response.data[i].type === 'INDV' || response.data[i].type === 'ENTP') {
this.role = response.data[i].type
break;
}
}
if (this.role === 'INDV' || this.role === 'ENTP') {
this.isLogin = true
this.$http.get('/api/v1/users/' + opid, obj)
.then(res => {
if (res.data.detail) {
this.name = res.data.detail.name;
this.mobile = res.data.detail.mobile
}
})
}
})
.catch((error) => {
if (error.response) {
if (error.response.data) {
this.$vux.alert.show({
title: '',
content: JSON.parse(error.response.data.error_message).zh_string,
})
}
}
})

})
.catch((error) => {
if (error.response) {
if (error.response.data) {
that.$vux.alert.show({
title: '',
content: JSON.parse(error.response.data.error_message).zh_string,
})
}
}
})
}
})
}
}



// WEBPACK FOOTER //
// ./src/components/srvpproject/filing.vue